import React from "react"
import { BackIcon, Box, Button, Link, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Link as RouterLink } from "react-router-dom"

export function InsuranceRecoveryFooter({
  onBack,
  children
}: React.PropsWithChildren<{ onBack: () => void }>): JSX.Element {
  return (
    <>
      <Typography>
        <FormattedMessage
          defaultMessage="Please <link>contact us</link> with any questions."
          values={{
            link: (chunks) => (
              <Link color="inherit" component={RouterLink} to="/care-team">
                {chunks}
              </Link>
            )
          }}
        />
      </Typography>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          inlineSize: "100%",
          gap: theme.spacing(theme.tokens.spacing.sm)
        })}
      >
        <Button
          onClick={onBack}
          variant="text"
          color="secondary"
          size="small"
          fullWidth={false}
          startIcon={<BackIcon />}
        >
          <FormattedMessage defaultMessage="Update insurance info" />
        </Button>
        {children}
      </Box>
    </>
  )
}
